import './style.css';

import React from 'react';

const Card = ({ children }) => {
  return <div className={'ec-card'}>{children}</div>;
};

export default Card;
